/* eslint-disable react/prop-types */
import { RightOutlined } from '@ant-design/icons';
import React from 'react';
import MarkerAdd from '../../../../assets/image/white_add_marker.png';
import useLegendStore from '../../../../store/legendStore';
import { useMarkerStore } from '../../../../store/markerStore';
import { LegendView } from '../../Legend/component/Legend/LegendView';
import styles from './IconTool.module.scss';

export interface IconToolProps extends React.HTMLAttributes<HTMLDivElement> {
  onCollapse: (bool: boolean) => void;
  collapseOpen: boolean;
  result: any;
  setResult: any;
  legendStartEndValues: [number | null, number | null];
  setLegendStartEndValues: (data: [number | null, number | null]) => void;
}

export default function IconTool(props: IconToolProps) {
  const {
    collapseOpen,
    setLegendStartEndValues,
    result,
    legendStartEndValues,
    setResult,
    onCollapse,
    ...rest
  } = props;
  const legend = useLegendStore((state) => state.legend);

  const markers = useMarkerStore((state) => state.markers);
  const isAddMarkerMode = useMarkerStore((state) => state.isAddMarkerMode);
  const setAddMarkerMode = useMarkerStore((state) => state.setAddMarkerMode);

  function onPanelCollapse() {
    if (markers.length === 0 && !isAddMarkerMode) {
      setAddMarkerMode(true);
      props.onCollapse(true);
    } else {
      props.onCollapse(!props.collapseOpen);
    }
  }

  return (
    <div className={`${styles.root} ${collapseOpen ? '' : styles.rootOpen}`}>
      <IconBox
        id='PointPanel-Collapsible_Button'
        className={`${styles.collapseBtn} ${
          collapseOpen ? '' : styles.collapseBtnOn
        }`}
        onClick={onPanelCollapse}
        {...rest}
      >
        {collapseOpen ? (
          <img src={MarkerAdd} width={25} alt='' />
        ) : (
          <RightOutlined />
        )}
      </IconBox>
      {legend?.display && markers.length > 0 && (
        <LegendView
          result={result}
          setLegendStartEndValues={setLegendStartEndValues}
        />
      )}
    </div>
  );
}

export function IconBox({
  id,
  style,
  className,
  onClick,
  children,
  ...rest
}: React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>) {
  return (
    <div
      id={id}
      style={style}
      className={`${styles.iconBox} ${className ? className : ''}`}
      onClick={onClick}
      {...rest}
    >
      {children}
    </div>
  );
}
